import { Box, Container } from "@mui/material";
import MontlyData from "../../components/trader/MontlyData";
import TraderInfo from "../../components/trader/TraderInfo";
import CreditToBePaid from "../../components/trader/CreditToBePaid";
import { LoggedHeader } from "../../components/LoggedHeader";

import "../../styles/scss/traderDashboard.scss";
import TraderFollowers from "../../components/trader/TraderFollowers";
import TraderTime from "../../components/trader/TraderTime";
import { useTraderProvider } from "../../providers/TraderProvider";
export const Trader = () => {
	const { currentTraderProfile } = useTraderProvider();
	return (
		<>
			<Container
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "16px",
					mt: "96px",
				}}
			>
				{/* <LoggedHeader /> */}
				{currentTraderProfile != null && (
					<TraderInfo trader={currentTraderProfile} />
				)}

				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					flexDirection="row"
					flexWrap="wrap"
					rowGap="16px"
				>
					<CreditToBePaid />
					{currentTraderProfile != null && (
						<>
							<TraderFollowers
								followers={currentTraderProfile.followers}
							/>
							<TraderTime
								startTime={currentTraderProfile.createdAt}
							/>
						</>
					)}
				</Box>
				<MontlyData />
			</Container>
		</>
	);
};
